import React from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import Loader from "./Loader";

const CustomSelectOption = styled.div`
  display: flex;
  flex-wrap: nowrap;
  align-items: center;

  padding: ${({ size }) => (size === "large" ? "4px 8px" : "1px 4px")};
  font-size: ${({ size }) => (size === "large" ? "12px" : "10px")};
  border: 1px solid ${({ borderColor }) => borderColor || "#99B0AD"};
  border-radius: 10px;
  cursor: pointer;
  background-color: ${({ isSelected }) =>
    isSelected ? "#99B0AD" : "transparent"};
  color: ${({ isSelected }) => (isSelected ? "#FAF6E9" : "black")};
  transition: all 0.2s ease-in-out;
  margin: ${({ size }) =>
    size === "large" ? "3px 5px 3px 0" : "1px 2px 1px 0"};

  &:hover {
    border-color: rgb(163, 175, 174);
  }
  user-select: none;
  -webkit-user-drag: none;
`;

const CustomSelectText = styled.span`
  font-size: ${({ size }) => (size === "large" ? "12px" : "11px")};
  display: inline-flex;
  align-items: center;
  white-space: nowrap;
`;

// ✅ Use $wrap so it won't be forwarded to the DOM.
// Also: actually use it to control wrapping behavior.
const CustomSelectContainer = styled.div`
  display: flex;
  flex-wrap: ${({ $wrap }) => ($wrap ? "wrap" : "nowrap")};
  align-items: center;
`;

function CustomSelectArray({
  items,
  onSelectChange,
  selectedItems,
  wrap = false,
  size, // optional: "large"
}) {
  const { t } = useTranslation();
  const handleItemClick = (item) => {
    if (selectedItems.includes(item)) {
      onSelectChange(
        selectedItems.filter((selectedItem) => selectedItem !== item),
      );
    } else {
      onSelectChange([...selectedItems, item]);
    }
  };

  return (
    <div>
      {Array.isArray(items) && selectedItems ? (
        <CustomSelectContainer $wrap={wrap}>
          {items.map((item, index) => (
            <CustomSelectOption
              key={item}
              id={`custom-select-option-${index}`}
              isSelected={selectedItems.includes(item)}
              onClick={() => handleItemClick(item)}
              size={size}
            >
              <CustomSelectText size={size}>
                {item === "Breakfast"
                  ? t("ui.i18nCleanup2.pequenoAlmoco")
                  : item === "Lunch"
                    ? t("ui.i18nCleanup2.almoco")
                    : item === "Dinner"
                      ? "Jantar"
                      : item}
              </CustomSelectText>
            </CustomSelectOption>
          ))}
        </CustomSelectContainer>
      ) : (
        <Loader />
      )}
    </div>
  );
}

export default CustomSelectArray;
